<div class="loading" *ngIf="status === statusWaiting">
	<div class="message" [innerHtml]="'status.waiting' | translate"></div>
</div>

<div class="loading redirect" [style.display]="status === statusRedirect? 'block' : 'none'">
	<div class="message">
		<p [innerHtml]="'status.redirect' | translate"></p>
		<p *ngIf="showCancelHint"><a class="button hollow" (click)="resetStatus()">{{'status.redirect.cancel' | translate}}</a></p>
	</div>
</div>

<div class="row columns" *ngIf="status === statusCanceled">
	<div class="status warning">
		<p>{{ 'status.canceled' | translate }}</p>
	</div>
</div>

<div class="row columns" *ngIf="status === statusError">
	<div class="status warning">
		<p *ngIf="message != 'payment.error_popup' && message != 'payment.error.newwindow'">
			{{ (message? message : 'status.error') | translate }}
		</p>
		<p *ngIf="message == 'payment.error_popup'">
			{{ message | translate}}
		</p>
		<p *ngIf="message == 'payment.error.newwindow'" [innerHTML]="'payment.error.newwindow' | translate: {'url': currentUrl()}"></p>
	</div>
</div>
